export { default } from "./QrCodeToDownloadApp";
